// Temporary full mix. Switch to 'stems' when the replacement tracks are ready.
export const SONG_PLAYBACK_MODE = 'full';
